// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

var defaultAuthenticationDetails = {
  status: "",
  error: ""
};

var defaultNextAction = {
  redirectToUrl: "",
  type_: "",
  next_action_data: undefined
};

var defaultIntent_associatedPaymentMethods = [];

var defaultIntent = {
  nextAction: defaultNextAction,
  id: "",
  customerId: "",
  clientSecret: "",
  authenticationDetails: defaultAuthenticationDetails,
  associatedPaymentMethods: defaultIntent_associatedPaymentMethods
};

var defaultToken = {
  type: "",
  data: ""
};

var defaultAssociatedPaymentMethodObj = {
  token: defaultToken,
  paymentMethodType: "",
  paymentMethodSubType: ""
};

function getNextAction(dict, str) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            redirectToUrl: Utils$OrcaPaymentPage.getString(json, "redirect_to_url", ""),
                            type_: Utils$OrcaPaymentPage.getString(json, "type", ""),
                            next_action_data: Utils$OrcaPaymentPage.getDictFromDict(json, "next_action_data")
                          };
                  })), defaultNextAction);
}

function getAuthenticationDetails(dict, str) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            status: Utils$OrcaPaymentPage.getString(json, "status", ""),
                            error: Utils$OrcaPaymentPage.getString(json, "status", "")
                          };
                  })), defaultAuthenticationDetails);
}

function getAssociatedPaymentMethods(dict) {
  return Utils$OrcaPaymentPage.getArray(dict, "associated_payment_methods").map(function (item) {
              var obj = Core__Option.getOr(Core__JSON.Decode.object(item), {});
              var tokenObj = Utils$OrcaPaymentPage.getDictFromDict(obj, "payment_method_token");
              return {
                      token: {
                        type: Utils$OrcaPaymentPage.getString(tokenObj, "type", ""),
                        data: Utils$OrcaPaymentPage.getString(tokenObj, "data", "")
                      },
                      paymentMethodType: Utils$OrcaPaymentPage.getString(obj, "payment_method_type", ""),
                      paymentMethodSubType: Utils$OrcaPaymentPage.getString(obj, "payment_method_subtype", "")
                    };
            });
}

function itemToPMMConfirmMapper(dict) {
  return {
          nextAction: getNextAction(dict, "next_action"),
          id: Utils$OrcaPaymentPage.getString(dict, "id", ""),
          customerId: Utils$OrcaPaymentPage.getString(dict, "customer_id", ""),
          clientSecret: Utils$OrcaPaymentPage.getString(dict, "client_secret", ""),
          authenticationDetails: getAuthenticationDetails(dict, "authentication_details"),
          associatedPaymentMethods: getAssociatedPaymentMethods(dict)
        };
}

export {
  defaultAuthenticationDetails ,
  defaultNextAction ,
  defaultIntent ,
  defaultToken ,
  defaultAssociatedPaymentMethodObj ,
  getNextAction ,
  getAuthenticationDetails ,
  getAssociatedPaymentMethods ,
  itemToPMMConfirmMapper ,
}
/* Utils-OrcaPaymentPage Not a pure module */
